import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ProblemDetails } from '@models/problem-details';

export abstract class ApiError extends Error implements Error {
  public override readonly cause: HttpErrorResponse;
  public readonly body: unknown;

  protected constructor(name: string, cause: HttpErrorResponse, body: unknown) {
    super(`${name}: ${cause.message}`);
    this.name = name;
    this.cause = cause;
    this.body = body;
  }

  public get url(): string | null {
    return this.cause.url;
  }

  public get status(): number {
    return this.cause.status;
  }

  public get statusText(): string {
    return this.cause.statusText;
  }

  public get headers(): HttpHeaders {
    return this.cause.headers;
  }

  // Get the body as a string if the Content-Type is text/plain
  public get text(): string | null {
    const contentType = this.headers.get('Content-Type');
    if (typeof this.body === 'string' && contentType === 'text/plain; charset=utf-8') {
      return this.body;
    }
    return null;
  }

  // Get the body as ProblemDetails if the Content-Type is application/problem+json
  public get problem(): ProblemDetails | null {
    const contentType = this.headers.get('Content-Type');
    if (typeof this.body === 'object' && contentType === 'application/problem+json; charset=utf-8') {
      return this.body as ProblemDetails;
    }
    return null;
  }

  // Get error key from either ProblemDetails or text body
  public get errorKey(): string | null {
    const problemDetail = this.problem?.detail;
    if (problemDetail) {
      return problemDetail;
    }

    const text = this.text;
    if (text) {
      return text;
    }

    return null;
  }
}
